import apiClient from "./client";
import type {
  GetLeaderboardParams,
  LeaderboardRow,
  WeeklyLeaderboard,
} from "@/types";

/**
 * Leaderboard API.
 * Backend endpoints:
 *   GET /leaderboard?skill=&limit=
 *   GET /leaderboard/weekly?limit=
 */

export async function getLeaderboard({
  skill = null,
  limit = 50,
}: GetLeaderboardParams = {}): Promise<LeaderboardRow[]> {
  const params: { limit: number; skill?: string } = { limit };
  if (skill) params.skill = skill;
  const { data } = await apiClient.get<LeaderboardRow[]>("/leaderboard", {
    params,
  });
  return data;
}

export async function getWeeklyLeaderboard({
  limit = 50,
}: { limit?: number } = {}): Promise<WeeklyLeaderboard> {
  const { data } = await apiClient.get<WeeklyLeaderboard>("/leaderboard/weekly", {
    params: { limit },
  });
  return data;
}
